export const MARKETING_TRAVEL_HERO = {
  label: 'Travel',
  message: 'Plan dog-first journeys',
  signal: 'Motion · cabin · location',
  status: 'Now testing',
} as const

export const MARKETING_TRAVEL_PRODUCT = {
  heading: 'Plan every dog-first journey',
  body: 'Prepare before departure, understand changing conditions on the way, and arrive with more context for your dog.',
  support:
    'Travel brings journey progress, supported vehicle signals, and location-based outside conditions into one experience.',
  disclosure:
    'Travel is now testing. Signal availability varies by vehicle and provider.',
} as const

export const MARKETING_TRAVEL_INTELLIGENCE = {
  name: 'Travel Intelligence',
  copy: 'Combines supported motion state, cabin temperature, climate status, vehicle location and journey progress with location-based outside conditions—helping you prepare, travel and arrive with more context for your dog.',
} as const

export const MARKETING_TRAVEL_HOW_IT_WORKS = {
  label: 'Travel',
  heading: 'Plan dog-first journeys',
  body: 'Prepare for every trip with dog-first travel intelligence. Works with supported vehicles; available signals vary by vehicle and provider.',
  status: 'Now testing',
} as const

export const MARKETING_TRAVEL_IMAGE = {
  src: '/marketing/wagamour-app-travel.png',
  alt: 'Wagamour Travel showing dog-first journey planning, Prepare, On the way and Arrive stages, and supported vehicle connection.',
  width: 473,
  height: 1024,
} as const
